import { render, staticRenderFns } from "./TestDo.vue?vue&type=template&id=5b3bfe4c&scoped=true"
import script from "./TestDo.vue?vue&type=script&lang=js"
export * from "./TestDo.vue?vue&type=script&lang=js"
import style0 from "./TestDo.vue?vue&type=style&index=0&id=5b3bfe4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3bfe4c",
  null
  
)

export default component.exports